import { render, staticRenderFns } from "./BaseInputCPF.vue?vue&type=template&id=87253708&"
import script from "./BaseInputCPF.vue?vue&type=script&lang=js&"
export * from "./BaseInputCPF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports